import React, { useEffect } from 'react';
import { Row, Col, Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { objectionFields } from './formField';
import { Upload, Modal } from 'components';
import { useNavigate } from 'react-router-dom';
import { FormField } from 'components';
import { omit } from 'lodash';
import { updateFormField } from 'store/forms/actions';
import { useDispatch, useSelector } from 'react-redux';
import { isBeneficiary ,isAuditor, isObjectionCommittee} from 'utils';
import { content } from './content';
import { submitConsentObjection } from '../../../../../store/forms/actions';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';
import { useParams } from 'react-router';
import DownloadedItems from 'pages/mainForms/mainFormAuditor/components/downloadedItems';
import { flattenDocs } from 'pages/mainForms/mainFormAuditor/components/utils'; 
const ObjectioncForm = () => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || isBeneficiary(user.groups) || isAuditor(user.groups);
  const objection = useSelector(state => state.forms.objection);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const consentByCommittee = useSelector(state => state.forms.objection.consentByCommittee);
  const params = useParams();
  const navigate = useNavigate();
  const docs = useSelector(state => state.forms.documents);
  const flatDocs = flattenDocs(docs);
  const isForeignSupplier = useSelector(state => state.forms.carrier.isForeignSupplier);

 useEffect(() => {
    form.setFieldsValue({
      objectionCommitteeComment: objection?.objectionCommitteeComment,
    }); 
  }, [form, objection]);

const handleChange = ({ key, type, event }) => {
  let newValue;
  if (type === 'text' || type === 'textarea' || type === 'radio') {
    newValue = event.target.value;
  } else if (type === 'date') {
    newValue = new Date(event).toLocaleDateString("en-US");
  } else if (type === 'select' || type === 'number' || type === 'switch') {
    newValue = event;
  } else if (type === 'checkbox') {
    newValue = event.target.checked;
  }


  dispatch(
    updateFormField({
      group: 'objection',
      key,
      value: newValue,
    })
  );
};

return (
  <div>
    <Form
      form={form}
      initialValues={
        {
          // ...carrier,
        }
      }
      trigger="onChange"
    >
        {/* {(!viewMode && isAuditor(user?.groups) && (activeTaskName === 'task.name.audit_application')) && */}
        {(!viewMode && isObjectionCommittee(user?.groups) && (activeTaskName === 'task.name.application_evaluation_before_committee')) &&
        <Modal
          isVisible={!consentByCommittee}
          // isVisible={false}
          Icon ={WarningBlue}
          width={400}
          okText={'Επιβεβαίωση'}
          cancelText={'Ακύρωση'}
          handleCancel={() => {
            dispatch(submitConsentObjection({ consent: false, taskId: params.taskId, navigate, isForeignSupplier }));
          }}
          handleConfirm={() => {
            dispatch(submitConsentObjection({ consent: true, taskId: params.taskId, navigate, isForeignSupplier }));
          }}
        >
          <div className="modal-submit-content">
            <div className="content-title">Δήλωση Μη Σύγκρουσης Συμφερόντων</div>
            <div className="content-paragraph">
            Με ατομική μου ευθύνη και γνωρίζοντας τις κυρώσεις που προβλέπονται από τις διατάξεις της παρ. 6 του άρθρου 22 του Ν. 1599/1986, δηλώνω ότι δεν τίθεται θέμα σύγκρουσης συμφερόντων με το Φορέα της Επένδυσης.
              <br />
              <div className="mt-1">
              Σε περίπτωση σύγκρουσης συμφερόντων οδηγήστε την αίτηση σε νέο Ανεξάρτητο Αξιολογητή. 
              </div>
            </div>
          </div>
        </Modal>
      }
        <Row style={{ width: '45%', display: 'inline-block' }}>
          {activeTaskName ==='task.name.application_evaluation_by_committee' && content().map((item, index) => {
            return (
              <Upload item={item} subFileCode={item.fileCode}  key={index} group={'documents'} />
            );
          })}
         {activeTaskName !=='task.name.application_evaluation_by_committee' && content().map((item, index) => {
              return (
                <DownloadedItems content={content()} docs={flatDocs}/>
              );
          })}
        </Row>
        <p className={`mt-3 color-blue-3 text-bold font-size-24`}>
          Αιτιολόγηση Εξέτασης Ένστασης<span className='color-asterisk'> *</span>
        </p>
        <Row style={{ width: '45%' }}>
          {objectionFields.map((field) => {
            return (
              <Col key={field.id} className="gutter-row" span={24}>
                <Form.Item
                  name={[field.name]}
                  rules={field.rules}
                >
                  <FormField
                    disabled={viewMode}
                    {...omit(field, ['span', 'rules'])}
                    onChange={value =>
                      handleChange({
                        key: field.name,
                        type: field.type,
                        event: value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
            );
          })}
        </Row>
    </Form>
  </div>
  );
};

export default ObjectioncForm;
